import Typed from 'react-typed';
import img from "../assets/portfolio.jpg";

const PrimaryMessage = (props) =>{

    return(
        <div className='container primary'>
    
         <section className='row image-section'>
            <div className='image-container'> 
                <img className='image' src={img}  alt='Nour wagdy nasr'/>
            </div>
         </section>

         <div className='row intro'>
            <h1 className='col-12' >Nour Wagdy Nasr</h1>
            <div className='typed col-12'>
                    <Typed
                            strings={[
                            'Senior Front-End Engineer'
                            ]}
                            typeSpeed={55}
                            backSpeed={20}
                            className='typed-ele'
                        > 
                    </Typed>
            </div>
         </div>
        

        </div>
    );

 }
 export default PrimaryMessage;